import React from "react";
import { Helmet } from "react-helmet-async";

const LocalBusinessSEO = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://goalflex.net/#localbusiness",
    name: "GoalFlex",
    description:
      "Minnesota's premier soccer community app. Find pickup games, book premium fields, and connect with 500+ active players. Rated 4.9/5 stars.",
    url: "https://goalflex.net",
    telephone: "+1-555-GOALFLEX",
    email: "contact@goalflex.net",
    address: {
      "@type": "PostalAddress",
      streetAddress: "2799 Rustic Pl #105",
      addressLocality: "St Paul",
      addressRegion: "MN",
      postalCode: "55117",
      addressCountry: "US",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 44.9778,
      longitude: -93.265,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "00:00",
      closes: "23:59",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "487",
      bestRating: "5",
      worstRating: "1",
    },
    priceRange: "Free",
    category: "Event technology service",
    areaServed: [
      {
        "@type": "State",
        name: "Minnesota",
      },
      {
        "@type": "City",
        name: "Minneapolis",
      },
      {
        "@type": "City",
        name: "St Paul",
      },
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Soccer Services",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Pickup Soccer Games",
            description: "Join organized pickup soccer games in your area",
          },
          price: "0",
          priceCurrency: "USD",
          availability: "https://schema.org/InStock",
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Soccer Field Booking",
            description: "Book premium soccer fields and facilities",
          },
          priceRange: "$10-25",
          priceCurrency: "USD",
          availability: "https://schema.org/InStock",
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Player Matching",
            description: "Connect with soccer players of similar skill levels",
          },
          price: "0",
          priceCurrency: "USD",
          availability: "https://schema.org/InStock",
        },
      ],
    },
    sameAs: [
      "https://apps.apple.com/us/app/goalflex/id6745612755",
      "https://play.google.com/store/apps/details?id=com.goalflex.app",
      "https://facebook.com/goalflexapp",
      "https://instagram.com/goalflexapp",
      "https://twitter.com/goalflexapp",
    ],
    logo: {
      "@type": "ImageObject",
      url: "https://goalflex.net/logo512.png",
      width: 512,
      height: 512,
    },
    image: [
      {
        "@type": "ImageObject",
        url: "https://goalflex.net/logo512.png",
        width: 512,
        height: 512,
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSEO;
